import React from 'react';
import { Link } from 'react-router-dom';
import OpenandCloseModal from '../TradeCurrency/OpenandCloseModal';
import ModalRateLoyaltyview from './ModalRateLoyaltyview';
import Modal from '../Components/Modal';
import { toast } from 'react-toastify';

function LoyaltyviewSystem() {
  const { openModal, handleOpenandCloseModal } = OpenandCloseModal();
  const lvArray = [
    {
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='28'
          height='28'
          viewBox='0 0 26 26'
        >
          <path
            fill='currentColor'
            d='M13 0c-1.7 0-3 1.3-3 3v6c0 1.7 1.3 3 3 3h6l4 4v-4c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3H13zm4.188 3h1.718l1.688 6h-1.5l-.407-1.5h-1.5L16.813 9H15.5l1.688-6zM18 4c-.1.4-.212.888-.313 1.188l-.28 1.312h1.187l-.282-1.313C18.113 4.888 18 4.4 18 4zM3 10c-1.7 0-3 1.3-3 3v6c0 1.7 1.3 3 3 3v4l4-4h6c1.7 0 3-1.3 3-3v-6h-3c-1.9 0-3.406-1.3-3.906-3H3zm4.594 2.906c1.7 0 2.5 1.4 2.5 3c0 1.4-.481 2.288-1.281 2.688c.4.2.874.306 1.374.406l-.374 1c-.7-.2-1.426-.512-2.126-.813c-.1-.1-.275-.093-.375-.093C6.112 18.994 5 18 5 16c0-1.7.994-3.094 2.594-3.094zm0 1.094c-.8 0-1.188.9-1.188 2c0 1.2.388 2 1.188 2c.8 0 1.218-.9 1.218-2s-.418-2-1.218-2z'
          />
        </svg>
      ),
      title: 'FAQ',
      body: ' See frequently ask questions',
      button: (
        <Link
          to='faq'
          className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 w-fit h-fit py-1.5 px-8 disabled:bg-b-mct bg-b-mc rounded relative'
          // onClick={() => handleOpenandCloseModal("withdrawbonus")}
        >
          view
        </Link>
      ),
    },
    // {
    //   icon: (
    //     <svg
    //       xmlns='http://www.w3.org/2000/svg'
    //       width='28'
    //       height='28'
    //       viewBox='0 0 24 24'
    //     >
    //       <path
    //         fill='currentColor'
    //         d='M6 14h3.075L15.1 7.95l-3-3.075l-6.1 6.05V14Zm6.05-5.1l-.95-.925l.975-.975l.925.95l-.95.95ZM11.2 14H18v-2h-4.8l-2 2ZM2 22V2h20v16H6l-4 4Z'
    //       />
    //     </svg>
    //   ),
    //   title: 'Rate Loyaltyview',
    //   body: 'Ratings and review loyaltyview system',
    //   button: (
    //     <button
    //       type='button'
    //       className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 w-fit h-fit py-1.5 px-8 disabled:bg-b-mct bg-b-mc rounded relative'
    //       onClick={() => handleOpenandCloseModal('rateLoyaltyview')}
    //     >
    //       Rate
    //     </button>
    //   ),
    // },
    {
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='28'
          height='28'
          viewBox='0 0 24 24'
        >
          <path
            fill='currentColor'
            d='M6 14h3.075L15.1 7.95l-3-3.075l-6.1 6.05V14Zm6.05-5.1l-.95-.925l.975-.975l.925.95l-.95.95ZM11.2 14H18v-2h-4.8l-2 2ZM2 22V2h20v16H6l-4 4Z'
          />
        </svg>
      ),
      title: 'Contact Us',
      body: 'How can we assist you?',
      button: (
        <Link
          to='contact-us'
          className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 w-fit h-fit py-1.5 px-8 disabled:bg-b-mct bg-b-mc rounded relative'
        >
          view
        </Link>
      ),
    },
    {
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='28'
          height='28'
          viewBox='0 0 24 24'
        >
          <path
            fill='currentColor'
            d='M21 6.3c0-.79-.47-1.51-1.19-1.83l-7-3.11c-.52-.23-1.11-.23-1.62 0l-7 3.11C3.47 4.79 3 5.51 3 6.3V11c0 5.55 3.84 10.74 9 12c2.3-.56 4.33-1.9 5.88-3.71l-3.12-3.12a4.994 4.994 0 0 1-6.29-.64a5.003 5.003 0 0 1 0-7.07a5.003 5.003 0 0 1 7.07 0a5.006 5.006 0 0 1 .64 6.29l2.9 2.9C20.29 15.69 21 13.38 21 11V6.3z'
          />
          <circle cx='12' cy='12' r='3' fill='currentColor' />
        </svg>
      ),
      title: 'Privacy Policies',
      body: 'Read loyaltyview terms and condition',
      button: (
        <Link
          to='privacypolicy'
          className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 w-fit h-fit py-1.5 px-8 disabled:bg-b-mct bg-b-mc rounded relative'
        >
          view
        </Link>
      ),
    },
    {
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='28'
          height='28'
          viewBox='0 0 24 24'
        >
          <path
            fill='currentColor'
            d='M21 6.3c0-.79-.47-1.51-1.19-1.83l-7-3.11c-.52-.23-1.11-.23-1.62 0l-7 3.11C3.47 4.79 3 5.51 3 6.3V11c0 5.55 3.84 10.74 9 12c2.3-.56 4.33-1.9 5.88-3.71l-3.12-3.12a4.994 4.994 0 0 1-6.29-.64a5.003 5.003 0 0 1 0-7.07a5.003 5.003 0 0 1 7.07 0a5.006 5.006 0 0 1 .64 6.29l2.9 2.9C20.29 15.69 21 13.38 21 11V6.3z'
          />
          <circle cx='12' cy='12' r='3' fill='currentColor' />
        </svg>
      ),
      title: 'Terms and Conditions',
      body: 'Read loyaltyview terms and condition',
      button: (
        <Link
          to='terms-and-conditons'
          className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 w-fit h-fit py-1.5 px-8 disabled:bg-b-mct bg-b-mc rounded relative'
        >
          view
        </Link>
      ),
    },
  ];

  const handleToast = (state, message) => {
    if (state === 'success') {
      toast.success(` ${message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (state === 'error') {
      toast.error(`${message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  return (
    <section>
      <div className='px-5 lg:px-32 py-4 md:py-8'>
        <h2 className='text-[18px] font-semibold pb-6'>About Loyaltyview</h2>
        {lvArray.map((data, index) => (
          <div
            className='border-t-hf flex flex-row justify-between py-6'
            key={index}
          >
            <div className='flex flex-row gap-4'>
              <p className=' text-s-bk'>{data?.icon}</p>
              <div className='flex flex-col '>
                <p>{data.title}</p>
                <p className='flex flex-row gap-2 items-center text- text-s-bk'>
                  {data.body}
                </p>
              </div>
            </div>
            {data.button}
          </div>
        ))}
      </div>
      <Modal open={openModal === 'rateLoyaltyview'}>
        <ModalRateLoyaltyview
          content={{ openModal, handleOpenandCloseModal, handleToast }}
        />
      </Modal>
    </section>
  );
}

export default LoyaltyviewSystem;
